import React, { useEffect, useContext, useState, useLayoutEffect } from "react"
import { useLocation } from "@reach/router"
import { pageLoad } from "../../components/utility/utils"
import GetBusinessMobile from "../../components/mobile/getBusinessMobile"
import GetMobile from "../../components/mobile/getMobile"
import MobileHeader from "../header/mobileMenu.js"
import AuthHeaderLayout from "../header/authHeaderLayout.js"
import { StateContext } from "../../contextApi"
import Footer from "../footer"
import ErrorModal from "../modals/errorModal"
import SuccessModal from "../modals/successModal"
import useDeviceDetect from "../utility/useDeviceDetect"
import FirebaseWrapper from "../wrapper/firebaseWrapper"
import NaijaActive from "../../assets/img/flags/naijaActive-c.inline.svg"
import UnitedKingdom from "../../assets/img/flags/uk-c.inline.svg"
import Panel from "./pages/panel"
import VizSensor from "react-visibility-sensor"
import WaitlistFormModal from "../modals/waitlistFormModal.js"
import AgreementPolicyModal from "../modals/AgreementPolicy.js"
import BVNFailedModal from "../modals/BVNFailed.js"
import DialBVNModal from "../modals/dialBVN.js"
import BVNVerifyModal from "../modals/verifyBVN.js"
import SocialShareIcon from "./pages/general/SocialShareIcon"
import DarkSuccessModal from "../modals/darkSuccessModal.js"
import DarkErrorModal from "../modals/darkFailedModal.js"

const BankingLayout = ({ children }) => {
  const [
    {
      mobile,
      error,
      success,
      waitlistForm,
      agreementPolicyForm,
      bvnFailedForm,
      dialBVNForm,
      verifyBVNForm,
      darkSuccessModal,
      darkFailedModal
    },
  ] = useContext(StateContext)
  const { isMobile } = useDeviceDetect()
  const location = useLocation()
  const [activeTab, setActiveTab] = useState("")
  const [activeCountryTab, setActiveCountryTab] = useState(false)
  const [selectedItem, setSelectedItem] = useState("")
  const [selectIndex, setSelectIndex] = useState(null)
  const [show, setShow] = useState(false)
  const [selectedCountry, setSelectedCountry] = useState(
    location?.pathname.includes("/en-ng/legal") ? 1 : 2
  )
  const [country, setCountry] = useState("Global")
  const [hide, setHide] = useState("")
  const [metaDescription, setMetaDescription] = useState("")

  function onChange(isVisible) {
    setHide(isVisible)
  }

  const homeSupportedUrls = [
    "/en-ng/legal/privacy-policy",
    "/en-gb/legal/privacy-policy",
    "/en-ng/legal/terms",
    "/en-gb/legal/terms",
    "/en-ng/legal/terms/business",
    "/en-ng/legal/information-security-policy",
    "/en-gb/legal/complaints-policy",
    "/en-ng/legal/cookie-policy",
    "/en-gb/legal/cookie-policy",
    "/en-ng/legal/disclaimer/investments",
    "/en-ng/legal/disclaimer/giftCards",
    "/en-ng/legal/faq",
    "/en-gb/legal/faq",
    "/en-ng/legal/faq/openApi",
    "/en-ng/legal/faq/business",
  ]

  const activeHomeTab = homeSupportedUrls?.filter(element => {
    return location?.pathname?.includes(element)
  })

  const legalSupportedUrls = ["/en-ng/legal", "/en-gb/legal"]

  const legalActiveHomeTab = legalSupportedUrls?.filter(element => {
    return location?.pathname?.includes(element)
  })

  let modal
  switch (true) {
    case error:
      modal = <ErrorModal />
      break
    case success.status:
      modal = <SuccessModal />
      break
    case waitlistForm:
      modal = <WaitlistFormModal />
      break
    case agreementPolicyForm:
      modal = <AgreementPolicyModal />
      break
    case bvnFailedForm:
      modal = <BVNFailedModal />
      break
    case dialBVNForm:
      modal = <DialBVNModal />
      break
    case verifyBVNForm:
      modal = <BVNVerifyModal />
      break
    case darkSuccessModal:
      modal = <DarkSuccessModal/>
      break;
    case darkFailedModal:
      modal = <DarkErrorModal/>
      break
    default:
      modal = null
      break
  }

  const activateTab = index => {
    setActiveTab(prevActiveTab => (prevActiveTab === index ? -1 : index))
    // setSelectedItem("");
  }

  const toggleActiveItem = key => {
    setSelectedItem(key)
  }

  const openTab = index => {
    setActiveCountryTab(prevActiveTab => (prevActiveTab === index ? -1 : index))
    setSelectedItem("")
  }

  const toggleCountry = key => {
    setSelectedItem(key)
    setSelectedCountry(key)
  }

  const countries = [
    {
      heading: "Nigeria",
      image: <NaijaActive />,
      list: [
        {
          title: "Nigeria",
          link: "/en-ng/legal/",
          id: 1,
          image: <NaijaActive />,
        },
        {
          title: "United Kingdom",
          link: "/en-gb/legal/",
          id: 2,
          image: <UnitedKingdom />,
        },
      ],
    },
  ]

  const panels = [
    {
      heading: "Terms & Conditions",
      list: [
        ...(selectedCountry === 1
          ? [
              {
                title: "Retail",
                link: "/en-ng/legal/terms/",
                id: 3,
              },
            ]
          : [
              {
                title: "Terms & Conditions",
                link: "/en-gb/legal/terms/",
                id: 4,
              },
            ]),

        ...(selectedCountry === 1
          ? [
              {
                title: "Business",
                link: "/en-ng/legal/terms/business/",
                id: 5,
              },
              {
                title: "Cards",
                link: "/en-ng/legal/cards/",
                id: 6,
              },
              {
                title: "Savings",
                link: "/en-ng/legal/savings/",
                id: 7,
              },
            ]
          : []),
      ],
    },
    {
      heading: "Policies",
      list: [
        ...(selectedCountry === 1
          ? [
              {
                title: "Privacy Policy",
                link: "/en-ng/legal/privacy-policy/",
                id: 8,
              },
            ]
          : [
              {
                title: "Privacy Policy",
                link: "/en-gb/legal/privacy-policy/",
                id: 9,
              },
            ]),

        ...(selectedCountry === 1
          ? [
              {
                title: "Information Security Policy",
                link: "/en-ng/legal/information-security-policy/",
                id: 10,
              },
            ]
          : []),

        ...(selectedCountry === 1
          ? []
          : [
              {
                title: "Complaints",
                link: "/en-gb/legal/complaints-policy/",
                id: 11,
              },
            ]),

        ...(selectedCountry === 1
          ? [
              {
                title: "Cookie Policy",
                link: "/en-ng/legal/cookie-policy/",
                id: 12,
              },
            ]
          : [
              {
                title: "Cookie Policy",
                link: "/en-gb/legal/cookie-policy/",
                id: 13,
              },
            ]),
      ],
    },
    ...(selectedCountry === 1
      ? [
          {
            heading: "Disclaimer",
            list: [
              {
                title: "Investments",
                link: "/en-ng/legal/disclaimer/investments/",
                id: 14,
              },
              {
                title: "Giftcards",
                link: "/en-ng/legal/disclaimer/giftCards/",
                id: 15,
              },
            ],
          },
        ]
      : []),

    {
      heading: "FAQs",
      list: [
        ...(selectedCountry === 1
          ? [
              {
                title: "FAQs",
                link: "/en-ng/legal/faq/",
                id: 16,
              },
            ]
          : [
              {
                title: "FAQs",
                link: "/en-gb/legal/faq/",
                id: 17,
              },
            ]),
        ...(selectedCountry === 1
          ? [
              {
                title: "Open Api FAQs",
                link: "/en-ng/legal/faq/openApi/",
                id: 18,
              },
            ]
          : []),
        ...(selectedCountry === 1
          ? [
              {
                title: "Kuda for Business FAQs",
                link: "/en-ng/legal/faq/business/",
                id: 19,
              },
            ]
          : []),
      ],
    },
  ]

  const selectedIndex = () => {
    let value = undefined
    panels.find((item, index) => {
      return item.list.find(listItem => {
        if (listItem.link === location.pathname) {
          value = { activeIndex: index, ...listItem }
          // return value
        }
        // return false;
      })
    })
    return value
  }

  useEffect(() => {
    if (
      location?.pathname.includes("/en-ng/legal/faq") ||
      location?.pathname.includes("/en-gb/legal/faq") ||
      location?.pathname.includes("/en-ng/legal/terms") ||
      location?.pathname.includes("/en-ng/legal/privacy-policy") ||
      location?.pathname.includes("/en-gb/legal/privacy-policy") ||
      location?.pathname.includes("/en-ng/legal/information-security-policy") ||
      location?.pathname.includes("/en-gb/legal/complaints-policy") ||
      location?.pathname.includes("/en-ng/legal/disclaimer/investments") ||
      location?.pathname.includes("/en-ng/legal/disclaimer/giftCards") ||
      location?.pathname.includes("/en-gb/legal/complaints-policy") ||
      location?.pathname.includes("/en-gb/legal/cookie-policy") ||
      location?.pathname.includes("/en-ng/legal/cookie-policy") ||
      location?.pathname.includes("/en-gb/legal/terms") ||
      location?.pathname.includes("/en-gb/legal") ||
      location?.pathname.includes("/en-ng/legal")
    ) {
      setShow(true)
    }
  }, [location])

  useLayoutEffect(() => {
    if (location?.pathname && location?.pathname.includes("/en-ng/legal")) {
      setSelectedCountry(1)
      setSelectedItem(selectedIndex()?.id)
      activateTab(selectedIndex()?.activeIndex)
      setSelectIndex(selectedIndex()?.activeIndex)
    } else if (
      location?.pathname &&
      location?.pathname.includes("/en-gb/legal")
    ) {
      setSelectedCountry(2)
      setSelectedItem(selectedIndex()?.id)
      activateTab(selectedIndex()?.activeIndex)
      setSelectIndex(selectedIndex()?.activeIndex)
    }
  }, [location?.pathname])

  useEffect(() => {
    pageLoad()
    window.scrollTo(0, 0)
  }, [])

  function isPathnameMoreThanBlog() {
    const pathname = location?.pathname
    const parts = pathname.split("/").filter(Boolean)

    if (parts[0] === "blog" && parts.length > 1) {
      return true
    }
    return false
  }

  useEffect(() => {
    if (isPathnameMoreThanBlog()) {
      if (typeof window !== "undefined") {
        const metaDescriptionElement = document.querySelector(
          'meta[name="description"]'
        )

        if (metaDescriptionElement) {
          setMetaDescription(metaDescriptionElement.getAttribute("content"))
        }
      }
    }
  }, [isPathnameMoreThanBlog()])

  function extractBlogTitle() {
    const pathname = location?.pathname
    const parts = pathname.split("/").filter(Boolean)

    return parts[1]?.replace(/-/g, " ")
  }

  return (
    <FirebaseWrapper>
      <div
        className={`kuda-entry ${
          isMobile.toString().includes("iPhone") ? "white" : "white"
        }`}
      >
        <div className="kuda-entry--wrap">
          <React.Fragment>
            <AuthHeaderLayout
              isMobile={isMobile}
              setSelectedCountry={setSelectedCountry}
              selectCountry={setCountry}
            />

            {/***** POLICY SIDEBAR *****/}
            <div className="legal-wrapper">
              <div
                className={`policy-sidebar ${
                  show && !hide
                    ? "visible-anim fadeInUp animated"
                    : "fade-anim fadeOutDown animated"
                } ${legalActiveHomeTab.length > 0 && "display"} `}
              >
                <div className="accordion country-sidebar" role="tablist">
                  {countries.map(({ heading, list, image }, index) => (
                    <Panel
                      key={index}
                      activeTab={activeCountryTab}
                      index={index}
                      question={
                        list.find(item => item.id === selectedCountry)?.title ||
                        heading
                      }
                      answer={list.filter(a => a.id !== selectedCountry)}
                      activateTab={() => openTab(index)}
                      setSelectedItem={e => toggleCountry(e)}
                      selectedItem={selectedItem}
                      icon
                      QuestionIcon={
                        list.find(item => item.id === selectedCountry)?.image ||
                        image
                      }
                      questionStyles={"mr-3"}
                      textStyles={"text-color"}
                    />
                  ))}
                </div>
                <div
                  className={`accordion panel-sidebar ${
                    activeHomeTab.length > 0 && "tab-item"
                  }`}
                  role="tablist"
                >
                  {panels.map(({ heading, list }, index) => (
                    <Panel
                      key={index}
                      activeTab={activeTab}
                      index={index}
                      question={heading}
                      answer={list}
                      activateTab={e => activateTab(e)}
                      setSelectedItem={e => toggleActiveItem(e, index)}
                      selectedItem={selectedItem}
                      selectIndex={selectIndex}
                      showGrey={list.find(
                        item => item.title === selectedIndex()?.title
                      )}
                    />
                  ))}
                </div>
              </div>

              <VizSensor onChange={onChange} partialVisibility={"bottom"}>
                <div
                  className={`kuda-preview container ${
                    activeHomeTab.length > 0 && "no-padding"
                  } ${legalActiveHomeTab.length > 0 && "no-pad"} `}
                >
                  {children}
                </div>
              </VizSensor>
            </div>
            <Footer />
          </React.Fragment>
        </div>

        {/***** MOBILE MENU *****/}
        {mobile !== false ? (
          <div className="kuda-mobile--menu">
            <MobileHeader selectedCountry={country} />
          </div>
        ) : null}

        {/***** MODALS *****/}
        {/* <div className="modal modal-sendMoney small-modal modal-backdrop fadeIn animated"> */}
        <div>{modal}</div>

        {/* **** App Badge **** */}
        {!Boolean(location?.pathname.includes("/careers")) && (
          <>
            {location?.pathname.includes("/busines") ? (
              <>
                {isPathnameMoreThanBlog() && (
                  <div className="mobile-sticky-social-icons">
                    <SocialShareIcon
                      blogSubtitle={metaDescription}
                      blogTitle={extractBlogTitle()}
                    />
                  </div>
                )}

                <GetBusinessMobile />
              </>
            ) : (
              <>
                {isPathnameMoreThanBlog() && (
                  <div className="mobile-sticky-social-icons">
                    <SocialShareIcon
                      blogSubtitle={metaDescription}
                      blogTitle={extractBlogTitle()}
                    />
                  </div>
                )}

                <GetMobile />
              </>
            )}
          </>
        )}
      </div>
    </FirebaseWrapper>
  )
}

export default BankingLayout
